import { DEMO_MODE_KEY, DEMO_USER_ID, MAX_BOOKMAKERS } from "./types";

export { DEMO_MODE_KEY, DEMO_USER_ID, MAX_BOOKMAKERS };

function hasWindow(): boolean {
  return typeof window !== "undefined";
}

export function isDemoMode(): boolean {
  if (!hasWindow()) return false;
  return window.localStorage.getItem(DEMO_MODE_KEY) === "true";
}

export function setDemoMode(enabled: boolean): void {
  if (!hasWindow()) return;
  if (enabled) window.localStorage.setItem(DEMO_MODE_KEY, "true");
  else window.localStorage.removeItem(DEMO_MODE_KEY);
}